import * as types from "./actionTypes";

// Action dispatchers

export const userCheckIsLoggedIn = (shouldForceTokenRefresh = false) => ({
  type: types.USER_CHECK_IS_LOGGED_IN,
  payload: shouldForceTokenRefresh,
});

export const userAttemptLogin = ({
  shouldRedirectToProfile = true,
  shouldOnboard = true,
} = {}) => ({
  type: types.AUTH_INITIATE_LOGIN,
  shouldRedirectToProfile,
  shouldOnboard,
});

export const userAttemptSignup = (brand) => ({
  type: types.AUTH_INITIATE_SIGNUP,
  brand,
});

export const authSetLoggedIn = (user) => ({
  type: types.AUTH_SET_LOGGED_IN,
  payload: user,
});

export const userAttemptForgottenPassword = () => ({
  type: types.AUTH_INITIATE_FORGOTTEN_PASSWORD,
});

export const userAttemptLogout = () => ({
  type: types.AUTH_INITIATE_LOGOUT,
});

export const authSetLoggedOut = () => ({
  type: types.AUTH_SET_LOGGED_OUT,
});

export const setIsAuthenticating = (isAuthenticating, userFlow) => ({
  type: types.SET_IS_AUTHENTICATING,
  payload: { isAuthenticating, userFlow },
});

export const authErrorSet = (error) => ({
  type: types.AUTH_ERROR_SET,
  payload: error,
});

export const authSetShouldRedirectToProfile = (shouldRedirectToProfile) => ({
  type: types.AUTH_SHOULD_REDIRECT_TO_PROFILE,
  payload: shouldRedirectToProfile,
});

export const authSetShouldOnboard = (shouldOnboard) => ({
  type: types.AUTH_SHOULD_ONBOARD,
  payload: shouldOnboard,
});
